<div class="-menu-navigator" *ngIf="title">
  <app-link class="-title" (click)="closeMenu()">
    <span class="-icon-container"><icon icon="l_left_ankle"></icon></span>{{title}}</app-link>
</div>
<div class="-menu-category">
  <div class="-default-category-menus" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
    <ng-container *ngFor="let category of products; let index = index; let isFirst = first">
      <div class="-default-category-menu" [ngClass]="{'-active-first': isFirst}">
        <app-link>{{ category.title }}</app-link>
        <div class="-menu-items-container">
          <app-link [to]="item.path" *ngFor="let item of category.children; let itemIndex = index" [ngClass]="{'-first': isFirst, '-last': isLast}">
            <menu-item-card [name]="item.title" [description]="item.description" [icon]="item.icon"></menu-item-card>
          </app-link>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="-special-category-menu" *ngIf="specialMenuPath && specialMenuTitle">
    <app-link [to]="specialMenuPath">{{specialMenuTitle}}</app-link>
  </div>
</div>
